// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoggedUser_wrapper__2he5o","text":"LoggedUser_text__3Dr2t","circle":"LoggedUser_circle__3PqTk","svgIcon":"LoggedUser_svgIcon__3qtzq"};